import { createRoute } from "@tanstack/react-router";

import { SubscribeScreen } from "@/components/kb/subscribe-screen";
import { rootRoute } from "./__root";

export const subscribeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/subscribe",
	component: SubscribeScreen,
});
